module.exports = __webpack_public_path__ + "html/upload-file.template.html";